import { Dropdown, Field, NumericInput, RadioGroup, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent, WorksheetBalanceFieldSet, WorksheetEquipmentDropdown } from 'Components/Worksheets/Core';
import { useSelector } from 'react-redux';
import { FractionTested, FractionTestedOptions, OversizeParticlesTreatment, UpperAggregateSievesize } from '../types';

let BsEnPreparationSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  var upperAggregateSieveSizeOptions = [
    { label: '63.0', value: UpperAggregateSievesize.Sieve63_0mm },
    { label: '56.0', value: UpperAggregateSievesize.Sieve56_0mm },
    { label: '53.0', value: UpperAggregateSievesize.Sieve53_0mm },
    { label: '50.0', value: UpperAggregateSievesize.Sieve50_0mm },
    { label: '≤ 45.0', value: UpperAggregateSievesize.Sieve45_0mm },
  ];

  var oversizeParticlesTreatment = [
    { label: 'No oversize', value: OversizeParticlesTreatment.NoOversize },
    { label: 'Oversize particles reduced', value: OversizeParticlesTreatment.OversizeParticlesReduced },
    { label: 'Oversize particles discarded', value: OversizeParticlesTreatment.OversizeParticlesDiscarded },
  ];

  var fractionsSieves = {
    [`${FractionTested.Sizes4mmTo31_5mm}`]: {
      bottomSieve: '4.00 mm',
      upperSieve: '31.5 mm',
    },
    [`${FractionTested.Sizes31_5mmTo63mm}`]: {
      bottomSieve: '31.5 mm',
      upperSieve: '63.0 mm',
    },
  };

  const fractionTested = useSelector(createWorksheetSelector!('Preparation.FractionTested'));

  const bottomSieveSize = fractionsSieves[fractionTested ?? '']?.bottomSieve;
  const upperSieveSize = fractionsSieves[fractionTested ?? '']?.upperSieve;

  return (
    <>
      <Field input={<RadioGroup />} name="Preparation.FractionTested" options={FractionTestedOptions} />

      <ListFieldSection heading="Preparation of Test Portion">
        <Field
          input={<WorksheetEquipmentDropdown />}
          equipmentType="sieve"
          label={`${bottomSieveSize} Sieve`}
          name={`Equipment.BottomSieve`}
          queryParams={{ SieveSize: bottomSieveSize }}
        />

        <Field
          input={<WorksheetEquipmentDropdown />}
          equipmentType="sieve"
          label={`${upperSieveSize} Sieve`}
          name={`Equipment.UpperSieve`}
          queryParams={{ SieveSize: upperSieveSize }}
        />

        <Field
          input={<RadioGroup />}
          name="Preparation.OversizeParticlesTreatment"
          options={oversizeParticlesTreatment}
          visible={fractionTested === FractionTested.Sizes31_5mmTo63mm}
        />
      </ListFieldSection>

      <ListFieldSection heading="Mass of Test Portion">
        <Field
          input={<Dropdown />}
          name="Preparation.UpperAggregateSieveSizeId"
          options={upperAggregateSieveSizeOptions}
          simpleValue
        />
        <Field input={<TextOutput />} name="Preparation.MinimumSampledMass" />
        <WorksheetBalanceFieldSet name="Equipment.Balance" />
        <Field input={<NumericInput />} name="Preparation.TareMass" />
        <Field input={<NumericInput />} name="Preparation.TarePlusSampledMass" />
        <Field input={<TextOutput />} name="Preparation.SampledMass" />
      </ListFieldSection>
    </>
  );
};

BsEnPreparationSection = withInjectedProps(BsEnPreparationSection);

export { BsEnPreparationSection };
export default BsEnPreparationSection;
